import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import Account from './modules/account'
import Document from './modules/document'
import Task from './modules/task'
import Employees from './modules/employees'
import Project from './modules/project'
import Reference from './modules/reference'
import Phase from './modules/phase'
import FinancingSource from './modules/financingSource'
import Contractor from './modules/contractor'
import Spending from './modules/spending'
import Issue from './modules/issue'
import IssueTracker from './modules/issueTracker'
import Reports from './modules/reports'
import Survey from './modules/survey'
import Resources from './modules/resources'
import Announcement from './modules/announcement'
import Docflow from './modules/docflow'
import Moderator from './modules/moderator'
import Filters from './modules/filters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Account,
    Document,
    Employees,
    Task,
    Project,
    Reference,
    Phase,
    FinancingSource,
    Contractor,
    Spending,
    Issue,
    IssueTracker,
    Reports,
    Survey,
    Resources,
    Announcement,
    Docflow,
    Moderator,
    Filters
  },
  state: {
    error: false,
    networkError: false,
    loading: false
  },
  mutations: {
    ERROR(state, error) {
      state.error = error
    },
    NETWORK_ERROR(state, error) {
      state.networkError = error
    },
    SET_LOADING(state, val) {
      state.loading = val
    }
  },
  plugins: [createPersistedState({
    key: 'WORKFLOW_FRONT_APP',
    storage: window.localStorage
  })]
})
